/* eslint-disable no-param-reassign */
import {ruleGroupMap,customerList, ruleCropSensitive,configCenterPage} from '@/api/orderRules'
import store from '@/store/index'
import {RULE_GROUP , RULE_TYPE,PARAMS_NAME,ConfigEnum} from '@/constants/ruleConfig'
import { getToken } from '../../utils/auth'

function handleFormat(group) {
  // 处理模块参数,转换成{group[index]:{}}的格式
  // eslint-disable-next-line no-return-assign, no-sequences
  return group.reduce((prev, cur) => ( prev[cur] = {}, prev), {})
}

function verify(state,{tenantId,customerCode},prop) { 
  // 验证是否需要去请求规则接口
  const { orderRules, currentCustomerCode, currentTenantId,sensitiveFields } = state;
  const isEqualCustomer =(currentCustomerCode&&currentCustomerCode!==customerCode)||(currentTenantId&&currentTenantId!==tenantId)
  if (prop === RULE_TYPE.orderRules) {
    return !orderRules || isEqualCustomer;
  } 
    return !sensitiveFields || isEqualCustomer;
}

async function getCustomer (params) { 
  const data = {
    ...params,
    cooperativeNatureCodes: [2, 4],
    ignoreTenant: true,
    statuses: [0],
  }
  const res = await customerList({ ...data },{size:1000})
  return res.records&&res.records.length?res.records:[]
}

function getCustoemrCodeList(data = []) { 
  return data.map(item => item.customerCode)
}

export default {
  namespaced: true,
  state: {
    orderRules: null,
    currentCustomerCode:null,
    currentTenantId: null,
    sensitiveFields: null,
    creditCode: null,
    customerCodes: null,
    config:{},
  },
  getters: {
    isOrderDemoVersion:(state) =>state.config[ConfigEnum.WAREHOUSE_ORDER_DEMO_VERSION_LIST].includes(state.currentCustomerCode), // 货主端仓下单演示版本名单
  },
  mutations: {
    SET_ORDER_RULES(state, rules) {
      state.orderRules = rules
    },
    SET_SENSITIVE_FIELDS(state, rules) {
      state.sensitiveFields = rules
    },
    SET_CURRENT_CUSTOMER_CODE(state, value) {
      state.currentCustomerCode = value
    },
    SET_CURRENT_TENANT_ID(state, value) {
      state.currentTenantId = value
    },
    SET_CREDIT_CODE(state, value) {
      state.creditCode = value
    },
    SET_CUSTOMER_COEDS(state, value) { 
      state.customerCodes = value
    },
    SET_CONFIG(state, value){
      state.config = {...value}
    }
  },
  actions: {
    async getOrderCrop({commit, state,dispatch}, type) {
      if (!getToken()) {
        return
      }
      const { creditCode,tenantId, customerCode, customers } = store.state.user;
      if (type === RULE_TYPE.orderRules) { 
        dispatch('getEnterprisAllCustomer',{commit, state})
      }
      const customerReqs = []
      if (creditCode) {
        customers.forEach(item => {
          customerReqs.push({
            customerCode: item.customerCode,
            carrierTenantId: item.tenantId
          })
        });
      } else {
        if(!tenantId) {
          return
        }
        customerReqs.push({
          customerCode,
          carrierTenantId: tenantId,
        })
      }
      const res = await ruleCropSensitive({customerReqs})
      commit(PARAMS_NAME[type], {
        SENSITIVE_FIELDS: res.result
      });
    },
    async getOrderRules({ commit, state,dispatch }, type) {
      const { tenantId, customerCode } = store.state.user;
      if (!verify(state, { tenantId, customerCode }, type)) return
      if (type === RULE_TYPE.orderRules) { 
        dispatch('getEnterprisAllCustomer',{commit, state})
      }
      const group = type === RULE_TYPE.orderRules ? [RULE_GROUP.PARENT_ORDER_MARK,RULE_GROUP.STATION_RANGE, RULE_GROUP.SKU_RANGE, RULE_GROUP.ORDER_CREATE_TIME_CHECK, RULE_GROUP.CUSTOM_FIELDS,RULE_GROUP.BEFORE_PRICING] : [RULE_GROUP.SENSITIVE_FIELDS];
      const res = await ruleGroupMap({
        customerCode,
        carrierTenantId: tenantId,
        groupMap:handleFormat(group)
      })
      commit(PARAMS_NAME[type], res);
      commit('SET_CURRENT_CUSTOMER_CODE', customerCode);
      commit('SET_CURRENT_TENANT_ID', tenantId);
    },
    async getEnterprisAllCustomer({ commit, state }) { 
      const { customerCode,tenantId } = store.state.user;
      const res = await getCustomer({ customerCode, ownerTenantId: tenantId })
      commit('SET_CREDIT_CODE',res&&res.length?res[0].creditCode:null)
      const customers = await getCustomer({ creditCode: state.creditCode })
      commit('SET_CUSTOMER_COEDS',getCustoemrCodeList(customers))
    },
    async getOrderConfigCenterPage({ commit }){
      const keyList = Object.values(ConfigEnum)
      const res = await configCenterPage({
         needConfigAttr: true, 
         configKeyList: keyList
      })
      const config = {};
      res.records.forEach(item=>{
        config[item.configKey] = item.configAttrList[0]?.configValue?.split(',')||[];
      })
      commit('SET_CONFIG', config)
    }
  }
}
